<template>
    <article id="page-work" class="page page-work">
        <WorkListMobile v-if="$root.mobileDetected" :works="works"/>
        <WorkListDesktop v-if="!$root.mobileDetected && works.length" :works="works" :goBack="workListGoBack"/>
    </article>
</template>

<script>

// libs
import gsap from 'gsap'

// Data
import {extractedImgs} from '../../__data'

// Components
import WorkListMobile from '../shared/WorkListMobile'
import WorkListDesktop from '../shared/WorkListDesktop'

// Utils
import params from '../../utils/params'
import MyEmitter from '../../helpers/MyEmitter'
import Utils from '../../utils/utils'

export default {
    name: "PageWork",
    components: {
        WorkListDesktop,
        WorkListMobile,
    },
    data: function(){
        return {
            works: []
        }
    },
    mounted: function(){

        // Mobile mode listen to document scroll
        if(this.$root.mobileDetected){
            this.attachEvents()
        }

        Utils.fetch("/work").then(res => {

            this.works = res.map((work, workIndex) => {

                let slug = work.slug
                let secondary = work.film_title
                let primary = work.director

                if(!slug){
                    console.warn("work " + workIndex + " do not have slug")
                    slug = ""
                }

                if(!secondary){
                    console.warn("work " + workIndex + " do not have secondary")
                    secondary = ""
                }

                if(!primary){
                    console.warn("work " + workIndex + " do not have primary")
                    primary = ""
                }

                return {
                    id: workIndex,
                    primary,
                    slug: slug,
                    secondary,
                    src: work.image,
                    text_is_dark: false,

                    // src: extractedImgs[Math.floor(Math.random() * extractedImgs.length)].src
                }
            }) 

            Utils.waitForRessourcesImages(this.works.map(w => w.src))

        })
    },

    beforeRouteLeave: function(to, from, next){

        this.removeEvents()

        if(to && to.name && to.name === "home"){

            let duration = 1.2 // according duration in SceneLogo._animateToHeaderState()


            // on desktop
            if(!this.$root.mobileDetected){

                MyEmitter.emit(params.Events.logoGoMiddle)

                // only on desktop
                gsap.to(this.$el, {
                    duration: .6,
                    opacity: 0
                })
            } 
            // on mobile
            else {
                MyEmitter.emit(params.Events.logoGoMiddleMobile, duration)
            }

            gsap.to("#page-home", {
                duration: duration, 
                ease: params.Animations.easeDecrement,
                onComplete: () => {
                    MyEmitter.emit(params.Events.exitWorkListDesktop)
                    next()
                },

                y: 0
            })

        } else {
            if(!this.$root.mobileDetected){

                // only on desktop
                gsap.to(this.$el, {
                    duration: .6,
                    onComplete: () => {
                        next()
                    },
                    opacity: 0
                })
            } else {
                next()
            }
        }

    },
    beforeRouteEnter: function(to, from, next){

        // is coming from home
        if(from.name && from.name === "home"){

            let duration = .8

            next(vm => {

                if(vm.$root.mobileDetected){
                    MyEmitter.emit(params.Events.logoGoHeaderMobile, duration)
                } else {
                    MyEmitter.emit(params.Events.logoGoHeader)
                }
                
                // Mobile mode there is no container slide out
                if(vm.$root.mobileDetected) {
                    gsap.to(vm.$parent.$el, {
                        duration: duration,
                        scrollTop: window.innerHeight,
                    })
                    return
                }

                gsap.to("#page-home", {
                    duration: 1.2, // according duration in SceneLogo._animateToHeaderState()
                    ease: params.Animations.easeDecrement,

                    y: "-100vh"
                })
            })
        } 
        else if(!from || (from && !from.name)){
            next(vm => {

                console.log("hihihi")
                if(vm.$root.mobileDetected){
                    vm.restoreScroll()
                }
            })
        }
        else {
            next()
        }
    },

    methods: {

        restoreScroll: function(){
            this.$parent.$el.scrollTop = window.innerHeight
        },

        workListGoBack: function(){
            this.$router.push("/")
        },

        onScrollDocument: function(){
            let scrollY = this.$parent.$el.scrollTop

            if(scrollY === 0){
                this.removeEvents()
                this.workListGoBack()
            }
        },

        attachEvents(){
            this.$parent.$el.addEventListener("scroll", this.onScrollDocument, {passive: true})
        },

        removeEvents(){
            this.$parent.$el.removeEventListener("scroll", this.onScrollDocument, {passive: true})
        },
    }
}
</script>

<style lang="scss">
    .page-work{

    }
</style>